import { bufferToHexString } from '@iotize/common/byte-converter';
import { BodyDecoder, BodyEncoder } from '@iotize/tap/client/api';

import { ConverterError } from '../error';

const EXPECTED_ARRAY_LENGTH = 6;

export class MacAddressStringConverter
  implements BodyEncoder<string>, BodyDecoder<string>
{
  protected static _instance?: MacAddressStringConverter = undefined;

  public decode(body: Uint8Array): string {
    if (!body || body.length !== EXPECTED_ARRAY_LENGTH) {
      throw ConverterError.unexpectedBufferSize(EXPECTED_ARRAY_LENGTH, body);
    }
    let result = '';
    for (var i = body.length - 1; i >= 0; i--) {
      const part = body.slice(i, i + 1);
      result += bufferToHexString(part).toUpperCase() + ':';
    }
    return result.substring(0, result.length - 1);
  }

  public encode(value: string): Uint8Array {
    const values = value
      .split(':')
      .map((v) => parseInt(v, 16) & 0xff)
      .reverse();
    if (values.length !== EXPECTED_ARRAY_LENGTH) {
      throw new Error('Invalid mac address format: ' + value);
    }
    return Uint8Array.from(values);
  }

  public static instance() {
    if (!MacAddressStringConverter._instance) {
      MacAddressStringConverter._instance = new MacAddressStringConverter();
    }
    return MacAddressStringConverter._instance;
  }
}
